import { useHttp, useHttpList } from '@/composable/service/useHttp';
import addressHttp, { ListPrefecturesResult } from '@/services/http/address.http';
import useAsyncState from '@/composable/service/useAsyncState';
import { onMounted } from 'vue';

export function useZip2Address() {
  const http = useHttp(addressHttp.zipToAddress);
  return {
    address: http.data,
    zip2Address: http.request,
    zip2AddressLoading: http.loading,
    zip2AddressError: http.error,
    ...http,
  };
}

export function useListPrefectures() {
  const http = useHttpList(addressHttp.listPrefectures, { singleton: true });
  http.prefs = http.data;

  const state = useAsyncState(http, { default: [] as ListPrefecturesResult });

  onMounted(async () => {
    await state.request({});
  });

  return {
    prefectures: state.data,
    listPrefectures: state.request,
    prefecturesLoading: state.loading,
    prefecturesError: state.error,
  };
}


export function getTownByPrefIdAndCityId() {
  const http = useHttpList(addressHttp.getTowns);
  return {
    towns: http.data,
    getTowns: http.request,
    townsLoading: http.loading,
    townsError: http.error,
    ...http,
  };
}

export function getTownInfoListByZipCode() {
  const http = useHttpList(addressHttp.getTownInfoListByZipCode);
  return {
    townsInfoList: http.data,
    getTownInfoList: http.request,
    townInfoListLoading: http.loading,
    townInfoListError: http.error,
    ...http,
  };
}

export function useGetPrefByFcShop() {
  const http = useHttpList(addressHttp.getPrefByFcShop, { singleton: true });
  return http;
}
